/* eslint-disable */
import React, { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import { useSelector } from 'store';
import { useDispatch } from 'store';
import { closeConfirmationModal, showLoading } from 'store/slices/confirmationModal';
import { LoadingButton } from '@mui/lab';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Box } from '@mui/system';
import { CompanyActions } from 'store/slices/listingCheck';

// ===============================|| UI DIALOG - RESPONSIVE ||=============================== //

export default function ConfirmationModal() {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const dispatch = useDispatch();
    const { open, handleConfirm, message, loading, listingNumber, islistingNumber } = useSelector((state) => state.confirmationModal);

    const [listNumber, setNumber] = useState('');
    const [exist, setExist] = useState(false);

    // const { loading: listingLoad, data, error } = useSelector((state) => state.ListingCheck);
    const { listingIdGet } = CompanyActions;

    const handleNumberChange = (event) => {
        if (exist) {
            setExist(false);
        }
        setNumber(event.target.value);
    };

    const handleClose = () => {
        dispatch(closeConfirmationModal());
    };

    const handleSubmit = async () => {
        if (message === 'Please click on submit to approve the property' || message === 'Please click on submit to reject the property') {
            dispatch(listingIdGet(listNumber))
                .then(async (res) => {
                    if (!res?.payload?.available) {
                        await dispatch(showLoading());
                        const res = await handleConfirm(listNumber);
                        setNumber('');
                        await dispatch(showLoading());
                        dispatch(closeConfirmationModal());
                    } else if (islistingNumber) {
                        await dispatch(showLoading());
                        const res = await handleConfirm(listNumber);
                        setNumber('');
                        await dispatch(showLoading());
                        dispatch(closeConfirmationModal());
                    } else {
                        setExist(true);
                    }
                })
                .catch((err) => {
                    openSnackbar({
                        open: true,
                        message: 'error',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true
                    });
                });
        } else {
            await dispatch(showLoading());
            const res = await handleConfirm();
            await dispatch(showLoading());
            dispatch(closeConfirmationModal());
        }
    };

    useEffect(() => {
        setNumber(listingNumber);
    }, [listingNumber]);

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    '& .MuiPaper-root': {
                        width: '400px'
                    }
                }}
            >
                {open && (
                    <>
                        {/* {!islistingNumber &&
                            (message === 'Please click on submit to approve the property' ||
                                message === 'Please click on submit to reject the property') && (
                                <DialogContent>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            Enter Listing ID
                                        </Typography>
                                        <TextField
                                            value={listNumber}
                                            onChange={handleNumberChange}
                                            inputProps={{
                                                'aria-label': 'enter number'
                                            }}
                                            sx={{ width: '60%' }}
                                            variant="outlined"
                                            color="primary"
                                        />
                                        {exist && (
                                            <Typography variant="body2" sx={{ mt: 1, color: 'red' }}>
                                                Listing ID Already Exist*
                                            </Typography>
                                        )}
                                    </Box>
                                </DialogContent>
                            )} */}

                        <DialogTitle id="responsive-dialog-title">Are you sure?</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Typography variant="body2" component="span">
                                    {message}
                                </Typography>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions sx={{ pr: 2.5 }}>
                            <Button sx={{ color: theme.palette.error.dark }} autoFocus onClick={handleClose} color="secondary">
                                cancel
                            </Button>
                            <LoadingButton
                                type="button"
                                variant="contained"
                                size="small"
                                onClick={handleSubmit}
                                autoFocus
                                loading={loading}
                            >
                                submit
                            </LoadingButton>
                        </DialogActions>
                    </>
                )}
            </Dialog>
        </div>
    );
}
